import { ApiClient } from "@/shared/services/api-client";
import { PutUsersIntegrationRequestModel, PutUsersIntegrationResponseModel } from "@/features/user/services/put-integration-model";
import { MoneyLinkException } from "@/shared/utils/custom-exception";

export class PutUsersIntegrationApi {
  /**
   * 利用者統合API
   */
  public putUsersIntegration = async (
    param: PutUsersIntegrationRequestModel
  ): Promise<PutUsersIntegrationResponseModel> => {
    const path = `/api/users/integration`;
    const res = await ApiClient.instance.put<PutUsersIntegrationResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
